module.exports = __webpack_public_path__ + "img/5d.2ca8fb99.png";